const ErrorContainer = ({ message, id }) => {
    return (
        <p id={id} className="text-xs text-[#FF675D] text-left text-uppercase" role="alert">
            {message}
        </p>
    );
};

export default ErrorContainer;
